export default __webpack_public_path__ + "static/media/css.19c8605d.png";